import {axiosRequest} from "../../api";
import {API_PATH} from "../../../constants";

export const DraftPrescriptionService = {
  getDraftPrescriptionList(params: any){ return axiosRequest('GET', API_PATH.DRAFT_PRESCRIPTION.LIST(params)) },
  getDraftPrescription(data: any){ return axiosRequest('POST', API_PATH.DRAFT_PRESCRIPTION.INFO, data) },
  addDraftPrescription(data: any){ return axiosRequest('POST', API_PATH.DRAFT_PRESCRIPTION.ADD, data) },
  deleteDraftPrescription(data: any){ return axiosRequest('POST', API_PATH.DRAFT_PRESCRIPTION.DELETE, data) },
}